import { RowTripPatternDto, TripPatternExportDto } from "@/dtos";
import { TripPattern, TripPatternPlotted } from "@/entities";
import { getTripPatternOrientationLabel, getTripPatternOrientationOption } from "@/helpers/options";
import { TripPatternOrientation } from "@/helpers/types";
import { MapCoordinate } from "@/ui/components/maps/common/interfaces/map-coordinate";
import { MapLine } from "@/ui/components/maps/common/interfaces/map-line";


export const formatRowTripPatternDto = (tripPatterns: TripPattern[]): RowTripPatternDto[] => {
    return tripPatterns.map((x) => {
        const row: RowTripPatternDto = {
            ...x,
            orientationLabel: getTripPatternOrientationLabel(x.orientation),
            active: (x.is_active) ? 'Activo' : 'Inactivo'
        }
        
        return row;
    });
}

export const formatPlottedToMapCoords = (plotteds: TripPatternPlotted[], name?: string): MapLine[] => {
    const lines = plotteds.map((x) => {
        const orientation = (TripPatternOrientation.OUTBOUND == x.type) ? 'outbound' : 'inbound';
       
        if (x.coords && x.coords.length > 0) {
            x.coords.sort((a,b) => a.order - b.order);
            const coords = x.coords.map((y) => {
                const coord: MapCoordinate = {
                    name: orientation,
                    coordinate: [y.longitude, y.latitude],
                    isPrimaryColor: (orientation == 'outbound') ? true : false
                }
                return coord;
            });
    
            const line: MapLine = {
                identification: name ?? orientation,
                coordinates: coords
            }
    
            return line;
        }
        const line: MapLine = {
            identification: name ?? orientation,
            coordinates: []
        }

        return line;
  
    });

    return lines;
}

export const formatExportTripPattern = (tripPatterns: TripPattern[]) => {
    return tripPatterns.map(x => {
        const row: TripPatternExportDto = {
            name: x.name,
            orientation_label: getTripPatternOrientationOption(x.orientation).label,
            distance: x.distance,
            route: x.route.long_name,
            active: x.is_active ? 'Activo' : 'Inactivo'
        }

        return row;
    });
}